const accessDoc = {
    BOQ_LIST: { name: 'BOQ List', path: '/boq-list' },
    ADD_BOQ: { name: 'Add BOQ', path: '/create-boq' },
    UPDATE_BOQ: { name: 'Update BOQ', path: '/edit-boq' },
    DELETE_BOQ: { name: 'Delete BOQ', path: '/delete-boq' },

    DATASHEET_LIST: { name: 'Datasheet List', path: '/datasheet-list' },
    ADD_DATASHEET: { name: 'Add Datasheet', path: '/create-datasheet' },
    UPDATE_DATASHEET: { name: 'Update Datasheet', path: '/edit-datasheet' },
    DELETE_DATASHEET: { name: 'Delete Datasheet', path: '/delete-datasheet' },
}

export default accessDoc;